// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";

import "trix"
import "@rails/actiontext"

// Подключение Chart.js
import Chart from 'chart.js/auto'
window.Chart = Chart
